<template>
  <div class="reviews-section">
    <div class="reviews-header">
      <h3>Отзывы</h3>
      <div class="reviews-average">
        Средний балл за все отзывы: <span class="average-value">{{ averageRating }}</span>
      </div>
    </div>
    <div class="reviews-list">
      <div 
        v-for="review in reviews" 
        :key="review.date" 
        class="review-item"
      >
        <div class="review-content">
          <div class="review-header">
            <div class="review-date">
              {{ formatDate(review.date) }}
            </div>
            <div class="review-rating">
              <div class="rating">
                <span 
                  v-for="i in 5" 
                  :key="i" 
                  :class="{ 'filled': i <= review.rate }"
                ></span>
              </div>
              <span class="rating-text">{{ review.rate }}/5</span>
            </div>
          </div>
          <div class="review-text">
            {{ review.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewsList",
  props: {
    reviews: {
      type: Array,
      required: true
    },
    averageRating: {
      type: [String, Number],
      required: true
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/../src/assets/style/variables.scss";
@import "@/../src/assets/style/rating.scss";

.reviews-section {
  margin-top: 2.4rem;
}

.reviews-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.4rem;
  
  h3 {
    margin: 0;
    font-size: 2.4rem;
    font-weight: 700;
    color: $blue-03;
  }
  
  .reviews-average {
    font-family: Circe, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
    font-weight: 400;
    font-size: 1.8rem;
    line-height: 2.4rem;
    letter-spacing: 0px;
    color: #333333;
    vertical-align: middle;
    
    .average-value {
      font-weight: 700;
      color: #333333;
    }
  }
}

  .reviews-list {
    .review-item {
      display: flex;
      margin-bottom: 2.4rem;
      padding-bottom: 2.4rem;
      border-bottom: 1px solid #E0E0E0;
      
      &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 2.4rem;
      }
    }
  
  .review-content {
    flex: 1;
  }
  
  .review-header {
    display: flex;
    align-items: center;
    margin-bottom: 0.8rem;
    flex-wrap: wrap;
    gap: 1.2rem;
  }
  
  .review-date {
    font-size: 1.4rem;
    color: $grey-02;
    margin-right: 1.2rem;
  }
  
  .review-rating {
    display: flex;
    align-items: center;
    margin-left: auto;
    
    .rating {
      margin-right: 0.8rem;
    }
    
    .rating-text {
      font-family: Circe, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 2.4rem;
      letter-spacing: 0%;
      color: #ED1B2F;
    }
  }
  
  .review-text {
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: $text;
    white-space: pre-line;
  }
}

@media (max-width: 768px) {
  .reviews-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1.2rem;
  }
  
  .review-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.8rem;
  }
  
  .review-rating {
    margin-left: 0;
  }
}
</style>
